import { ExceptionService } from '../services/exception.service';
// import { validate } from 'codelyzer/walkerFactory/walkerFn';
import {
  Component, Input, Output, EventEmitter, OnInit, OnChanges, OnDestroy,
  SimpleChanges,
  //Inject, AfterContentChecked,
  ChangeDetectorRef, /*group,*/
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, UntypedFormArray } from '@angular/forms';
import {
  TogetherAuctionDIPApplicantDetails,
  TogetherAuctionDIPApplicantDetailsLegalBodyRoleAddresses,
  // TogetherAuctionDIPEquifaxAddress,
  // TogetherAuctionDIPIncomeDetails_PaymentPeriodType,
  TogetherAuctionDIPLoanDetails,
  // TogetherBaseAddress,
  CaseApplicantMarketingPreferenceResponse,
} from './../models/api.models';
import { NodeAPIService } from './../services/node.api.service';
import { NodeAPIEntityService } from './../services/node.entity.service';
import {
  TogetherAuctionDIPEntityType,
  // TogetherAuctionDIPEntityOperation,
  MarketingPreferenceCommunicationType,
} from './../models/enums';
import * as _ from 'lodash-es';
import moment from 'moment';
import {
  // map,
  takeUntil
} from 'rxjs/operators';
import {
  // Observable,
  Subject
} from 'rxjs';
// import { emit } from 'cluster';
// import { iteratorToArray } from '@angular/animations/browser/src/util';
// import { isArray } from 'util';
// import { isNewline } from 'codelyzer/angular/styles/cssLexer';

/**
 *
 * @export
 * @class TogetherAuctionDIPApplicantDetailComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 * @implements {OnDestroy}
 */
@Component({
    selector: 'together-auction-dip-applicant',
    templateUrl: './dip.applicant.component.html',
    providers: [NodeAPIService],
    standalone: false
})
export class TogetherAuctionDIPApplicantDetailComponent implements OnInit, OnChanges, OnDestroy {


  /**
   * The max addresses to allow on the application to prevent huge overload.
   *
   * @type {number}
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  private MAX_ADDRESSES: number = 4;

  /**
   *
   * @param {string} day
   * @param {string} month
   * @param {string} year
   * @param {string} marketingVal
   * @returns
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  validateFields(day: string, month: string, year: string, marketingVal: string) {
    return (group: UntypedFormGroup): { [key: string]: any } => {
      const dayControl = group.controls[day];
      const monthControl = group.controls[month];
      const yearControl = group.controls[year];
      const marketVal = group.controls[marketingVal];

      const _day = dayControl.value;
      const _month = monthControl.value - 1;
      const _year = yearControl.value;

      const day_valid = dayControl.valid;
      const month_valid = monthControl.valid;
      const year_valid = yearControl.valid;

      const fields_valid = day_valid && month_valid && year_valid;
      const fields_dirty = dayControl.dirty && monthControl.dirty && yearControl.dirty;
      const date = moment([_year, _month, _day]);
      const today = moment().startOf('day');

      if (fields_dirty === false) {
        return null;
      }

      const result = {
        isUnderage: false,
        hasInvalidDate: false,
        isOkToContactNotSelected: false,
      };
      if (date.isValid() && fields_valid) {
        const age_cutoff = today.subtract({ years: 18 });
        const age_diff = date.diff(age_cutoff, 'day');
        const is_underage = age_diff > 0;
        if (is_underage) {
          result.isUnderage = true;
          return result;
        }
      } else {
        result.hasInvalidDate = true;
        return result;
      }
      if (marketVal.invalid) {
        result.isOkToContactNotSelected = true;
        return result;
      }
      return null;
    };
  }

  tad_address_applicant_number = new UntypedFormControl(null, []);
  // Don't add any validation, used for pass only.
  tad_applicant_title: UntypedFormControl = new UntypedFormControl(null, [
    Validators.required,
  ]);
  tad_first_name: UntypedFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.pattern(/^[A-Za-z -]+$/),
  ]);
  tad_middle_name: UntypedFormControl = new UntypedFormControl('', [
    Validators.pattern(/^[A-Za-z -]+$/),
  ]);
  tad_last_name: UntypedFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.pattern(/^[A-Za-z -]+$/),
  ]);
  tad_dob_day: UntypedFormControl = new UntypedFormControl(null, [
    Validators.min(1),
    Validators.max(31),
    Validators.minLength(1),
    Validators.maxLength(2),
    Validators.required,
  ]);
  tad_dob_month: UntypedFormControl = new UntypedFormControl(null, [
    Validators.min(1),
    Validators.max(12),
    Validators.minLength(1),
    Validators.maxLength(2),
    Validators.required,
  ]);
  tad_dob_year: UntypedFormControl = new UntypedFormControl(null, [
    Validators.min(1900),
    Validators.minLength(4),
    Validators.maxLength(4),
    Validators.required,
  ]);
  tad_main_phone_number: UntypedFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.minLength(7),
    Validators.pattern(/([0-9]+){7,10}/),
  ]);


  tad_email_address: UntypedFormControl = new UntypedFormControl('', [
    Validators.required,
    // tslint:disable-next-line:max-line-length
    Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
  ]);
  tad_marketing_approval: UntypedFormControl = new UntypedFormControl(null, [
  ]);
  tad_property_house_name_number: UntypedFormControl = new UntypedFormControl(null, []);
  tad_property_street_1: UntypedFormControl = new UntypedFormControl(null, []);
  tad_property_town_city: UntypedFormControl = new UntypedFormControl(null, []);
  tad_property_district: UntypedFormControl = new UntypedFormControl(null, []);
  tad_property_county: UntypedFormControl = new UntypedFormControl(null, []);
  tad_property_postcode: UntypedFormControl = new UntypedFormControl(null, []);
  phone: UntypedFormControl = new UntypedFormControl(false);
  email: UntypedFormControl = new UntypedFormControl(false);
  sms: UntypedFormControl = new UntypedFormControl(false);
  post: UntypedFormControl = new UntypedFormControl(false);
  tad_moved_in_date_month: UntypedFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.min(1),
    Validators.max(12),
  ]);
  tad_moved_in_date_year: UntypedFormControl = new UntypedFormControl('', [
    Validators.min(1900),
    Validators.max(new Date().getFullYear()),
  ]);
  tad_addresses: UntypedFormArray = new UntypedFormArray([]);
  address_search: UntypedFormArray = new UntypedFormArray([]);

  tad_applicant_details_form: UntypedFormGroup;
  @Input() stage: string;
  @Input() incoming_case_id: string;
  @Input() iterator: number;
  @Input() applicant: TogetherAuctionDIPApplicantDetails;
  @Input() do_save: boolean;
  @Input() business_details: UntypedFormGroup;
  @Input() do_validate: boolean;
  @Input() is_business_applicant: boolean;
  @Input() hasLived3yearSelected: boolean;
  @Input() hasPostCodeNotEntered: boolean;
  @Input() loan_details: TogetherAuctionDIPLoanDetails;
  @Input() isSubmitting: boolean = false;
  @Input() hasTitleNotSelected: boolean = false;
  @Input() collapseAllApplicant: boolean;

  @Output() stage_changing: EventEmitter<string> = new EventEmitter<string>();
  @Output() pass_form: EventEmitter<UntypedFormGroup> = new EventEmitter<UntypedFormGroup>();
  @Output() save_success = new EventEmitter();
  @Output() save_error = new EventEmitter();
  @Output() applicant_updated = new EventEmitter();
  @Output() applicant_deleted: EventEmitter<object> = new EventEmitter<object>();
  @Output() hasPreviousApplicantSaved: EventEmitter<object> = new EventEmitter<object>();
  @Output() updating_loading_status: EventEmitter<object> = new EventEmitter<object>();
  @Output() lookupFormOut: EventEmitter<object> = new EventEmitter<object>();
  _notifications: Array<object> = [];
  savePreviousApplicant: boolean = false;
  isToggleClicked: boolean = false;

  value: any = {};
  _addressResults: Array<object> = [];
  __addresses: Array<TogetherAuctionDIPApplicantDetailsLegalBodyRoleAddresses> = [];
  _movedInDates: Array<Date> = [];
  clientAddressId: string;
  _isLoading: boolean = false;
  _haslived3year: boolean;
  _showDeleteConfirmation: boolean = false;

  _movedInAddresses: Array<any> = [];
  changedYear: number = 0;
  appMarketingPreferences: CaseApplicantMarketingPreferenceResponse[] = [
    new CaseApplicantMarketingPreferenceResponse({
      MarketingPreferenceQuestionId: 1,
    }),
  ];

  private ngUnsubscribe: Subject<void> = new Subject();
  private ngUnsubscribeDelete: Subject<void> = new Subject();


  get tad_applicant_title_store() {
    return this.tad_applicant_title;
  }

  get emailValue() {
    return this.email.value === true ? 'yes' : 'no';
  }

  set tad_applicant_title_store(val) {

    let value = val;

    if (val instanceof UntypedFormControl) {
      value = val.value;
    }
    this.tad_applicant_title.setValue(value);
  }


  set isLoading(val: boolean) {
    if (this._isLoading === val) {
      return;
    }
    const seq = this.applicant.Instance.ApplicantSequence;
    this.updating_loading_status.emit({
      component: 'applicants',
      parameter: seq, // There is only one business applicant.
      status: val,
    });
    this._isLoading = val;
  }

  get _addresses() {
    return this.__addresses;
  }

  set _addresses(newVal) {
    this.__addresses = newVal;
  }

  get movedInAddresses() {
    return this._movedInAddresses;
  }

  set movedInAddresses(newVal) {
    this._movedInAddresses = newVal;
  }

  get isNewApplicant() {
    return !_.isNil(this.applicant.Instance) && this.api.isNew(this.applicant.Instance.Id);
  }



  get canDeleteApplicant() {
    const currentApplicant = this.applicant.Instance.ApplicantSequence;
    return (this.is_business_applicant === true && currentApplicant !== 2) ||
      (this.is_business_applicant === false && currentApplicant !== 1);
  }

  get hasMultipleAddresses() {
    if (this.applicant.Instance.LegalBodyRoleAddresses.length === 1 &&
      !_.isNil(this.applicant.Instance.LegalBodyRoleAddresses[0].EffectiveFromDate)) {
      return true;
    }

    return this.applicant.Instance.LegalBodyRoleAddresses.length > 1;
  }

  /**
   * Variable for toggle of delete dialog for this applicant.
   *
   * @type {boolean}
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  _showDeleteDialog: boolean = false;

  /**
   * Toggles the applicant details on each available applicant.
   *
   * @type {boolean}
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  _showApplicantDetails: boolean = true;

  /**
   * Handler functions for UI and toggling.
   */

  /**
   * Toggle applicant details.
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  _toggleApplicantDetails() {
    this.isToggleClicked = true;
    this._showApplicantDetails = !this._showApplicantDetails;
  }

  /**
   * Toggles delete dialog.
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  _toggleDeleteDialog() {
    this._showDeleteDialog = !this._showDeleteDialog;
  }

  /**
   * Toggle if applicant details are visible.
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  _isApplicantDetailsVisible() {
    if (this.isToggleClicked) {
      // console.log('showAplicantDetails:', this._showApplicantDetails);
      return this._showApplicantDetails;
    }

    this._showApplicantDetails = (!_.isNil(this.applicant.Instance) &&
      this.api.isNew(this.applicant.Instance.Id) === true);
    return this._showApplicantDetails;
  }

  /**
   * Shows if delete dialog is visible.
   *
   * @returns
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  _isDeleteDialogVisible() {
    return this._showDeleteDialog;
  }

  /**
   * Handles save of applicant success.
   * TODO: Bind to implicit class.
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  _handleSaveApplicantSuccess(success) {
    this.save_success.emit(success);
  }

  /**
   * Handles save of applicant.
   * TODO: Bind to implicit class.
   *
   * @param {any} error
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  _handleSaveApplicantError(error) {
    this.save_error.emit(error);
  }

  /**
   * Handles deletion of applicant.
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  _handleDeleteApplicant() {
    this.applicant_deleted.emit({
      iterator: this.applicant.Instance.ApplicantSequence,
      applicant_id: this.applicant.Instance.Id,
    });
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  _handleOutputFormValid() {
    this.pass_form.emit(this.tad_applicant_details_form);
  }

  /**
   *
   *
   * @param {any} error
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  _handleError(error) {
    this._notifications.push({ title: error });
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  prepareMovedInAddress() {
    if (!_.isNil(this._addresses)) {
      this.movedInAddresses = _.transform(this._addresses, (iter, n) => {
        const out = {};
        out['LegalBodyRoleAddress'] = n;
        iter.push(out);
        return true;
      }, []);
    }
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  handleAddresses() {
    this._addresses = this.applicant.Instance['LegalBodyRoleAddresses'];
    this.prepareMovedInAddress();
    this.isLoading = false;
    if (this.savePreviousApplicant && !this.isSubmitting) {
      this._showApplicantDetails = false;
      this.hasPreviousApplicantSaved.emit({
        isPreviousApplicantSaved: true,
        ApplicantSequence: this.applicant.Instance['Id'],
      });
    } else {
      this.save_success.emit({ iterator: this.iterator });
    }
  }


  /**
   *
   *
   * @param {any} case_id
   * @param {any} entity_id
   * @param {any} entity
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  _handleSaveData(case_id, entity_id, entity) {
    this.isLoading = true;
    this.api.saveEntities(
      TogetherAuctionDIPEntityType.ApplicantsPersonal,
      case_id,
      entity_id,
      entity,
    ).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (success) => {
          this.applicant = new TogetherAuctionDIPApplicantDetails(
            this.iterator,
            success as Object,
          );  // TODO: Handle iterator
          this.handleAddresses();
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.exception.haveReceivedError(error);
        },
      );
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  handleInit() {
    this.tad_applicant_details_form.addControl('tad_addresses', new UntypedFormArray([]));
    this.hasPostCodeNotEntered = false;
    this.prepareApplicantForm();
    this._handleOutputFormValid();
  }

  /**
   *
   * @param {SimpleChanges} changes
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  ngOnChanges(changes: SimpleChanges) {
    if (_.isNil(changes['do_save']) === false) {
      const do_save = changes['do_save'];
      if (do_save.previousValue === false && do_save.currentValue === true) {
        this._handleSaveData(this.incoming_case_id,
          this.applicant.Instance.Id, this.applicant.Instance);
      }
    }

    if (_.isNil(changes['collapseAllApplicant']) === false) {
      const collapseAllApplicant = changes['collapseAllApplicant'];
      if (collapseAllApplicant.previousValue === false
        && collapseAllApplicant.currentValue === true) {
        this.savePreviousApplicant = true;
      }
    }
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  ngOnInit() {
    this.handleInit();
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.ngUnsubscribeDelete.next();
    this.ngUnsubscribeDelete.complete();
    // if (!_.isNil(this.applicant &&
    //     this.api.isNew(this.applicant.Instance.Id) === false))
    //     this._showApplicantDetails = false;
  }


  /**
   * After content is checked, update the changes.
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  ngAfterContentChecked() {
    this.prepareApplicantSave(false);
    this._handleOutputFormValid();
    this.handleForm();
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  prepareApplicantAddress() {
    if (!_.isNil(this.applicant)) {
      if (_.size(this.applicant.Instance.LegalBodyRoleAddresses) > 0) {
        this._addresses = this.applicant.Instance.LegalBodyRoleAddresses.
          map(resp => new TogetherAuctionDIPApplicantDetailsLegalBodyRoleAddresses(resp));
        this._movedInDates = this.applicant.Instance.LegalBodyRoleAddresses.map((resp) => {
          return moment(resp.EffectiveFromDate).toDate();
        });
        this.prepareMovedInAddress();
      }
    }
  }


  /**
   *
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  prepareApplicantForm() {
    if (!_.isNil(this.applicant)) {
      if ((this.is_business_applicant === false &&
        this.applicant.Instance.ApplicantSequence === 1) ||
        (this.is_business_applicant === true &&
          this.applicant.Instance.ApplicantSequence === 2)) {
        this.tad_marketing_approval.setValidators(Validators.required);
      }
      this.tad_applicant_title.setValue(this.applicant.Instance.Title);
      this.tad_first_name.setValue(this.applicant.Instance.FirstName);
      this.tad_middle_name.setValue(this.applicant.Instance.MiddleName);
      this.tad_last_name.setValue(this.applicant.Instance.Surname);

      if (_.isNil(this.applicant.Instance._DateOfBirth) === false) {
        const dob = this.applicant.Instance._DateOfBirth;
        const day = dob.getDate();
        const month = dob.getMonth() + 1;
        const year = dob.getFullYear();

        this.tad_dob_day.setValue(day);
        this.tad_dob_month.setValue(month);
        this.tad_dob_year.setValue(year);
      }
      if (_.isNil(this.applicant.Instance.ApplicantMarketingPreference) === false &&
        _.isArray(this.applicant.Instance.ApplicantMarketingPreference.CaseApplicantMarketingPreferences) &&
        this.applicant.Instance.CaseApplicantMarketingPreferences.length > 0) {
        this.applicant.Instance.MarketingPreferences =
          this.applicant.Instance.CaseApplicantMarketingPreferences;
        this.appMarketingPreferences =
          this.applicant.Instance.CaseApplicantMarketingPreferences;
        this.email =
          new UntypedFormControl(_.some(this.applicant.Instance.CaseApplicantMarketingPreferences,
            ['ContactByEmail', true]));
        this.phone =
          new UntypedFormControl(_.some(this.applicant.Instance.CaseApplicantMarketingPreferences,
            ['ContactByPhone', true]));
        this.post =
          new UntypedFormControl(_.some(this.applicant.Instance.CaseApplicantMarketingPreferences,
            ['ContactByPost', true]));
        this.sms =
          new UntypedFormControl(_.some(this.applicant.Instance.CaseApplicantMarketingPreferences,
            ['ContactByTextOrSMS', true]));

      }
      // this.phone.setValue(_.some(contactByPhones, [ContactByPhone ])
      this.tad_main_phone_number.setValue(this.applicant._ui_phone_number);
      this.tad_email_address.setValue(this.applicant._ui_email_address);
      this.tad_address_applicant_number.setValue(this.applicant.Instance.ApplicantSequence);
      this.tad_marketing_approval.setValue(this.applicant.Instance.OkToContact);
      this.prepareApplicantAddress();
      this.handleMarketingPreferenceCheckBoxes();
    }
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  handleMarketingPreferenceCheckBoxes() {
    this.email.valueChanges.subscribe((val) => {
      if (val) {
        this.appMarketingPreferences[0].ContactByEmail = true;
      } else {
        this.appMarketingPreferences[0].ContactByEmail = false;
      }
      this.appMarketingPreferences[0].CaseApplicantId = this.applicant.Instance.Id;
      this.appMarketingPreferences[0].CommunicationTypeId =
        MarketingPreferenceCommunicationType.Email;
      this.applicant.Instance.MarketingPreferences = this.appMarketingPreferences;
    });

    this.post.valueChanges.subscribe((val) => {
      if (val) {
        this.appMarketingPreferences[0].ContactByPost = true;
      } else {
        this.appMarketingPreferences[0].ContactByPost = false;
      }
      this.appMarketingPreferences[0].CaseApplicantId = this.applicant.Instance.Id;
      this.appMarketingPreferences[0].CommunicationTypeId =
        MarketingPreferenceCommunicationType.Post;
      this.applicant.Instance.MarketingPreferences = this.appMarketingPreferences;
    });

    this.phone.valueChanges.subscribe((val) => {
      if (val) {
        this.appMarketingPreferences[0].ContactByPhone = true;
      } else {
        this.appMarketingPreferences[0].ContactByPhone = false;
      }
      this.appMarketingPreferences[0].CaseApplicantId = this.applicant.Instance.Id;
      this.appMarketingPreferences[0].CommunicationTypeId =
        MarketingPreferenceCommunicationType.Telephone;
      this.applicant.Instance.MarketingPreferences = this.appMarketingPreferences;
    });

    this.sms.valueChanges.subscribe((val) => {
      if (val) {
        this.appMarketingPreferences[0].ContactByTextOrSMS = true;
      } else {
        this.appMarketingPreferences[0].ContactByTextOrSMS = false;
      }
      this.appMarketingPreferences[0].CaseApplicantId = this.applicant.Instance.Id;
      this.appMarketingPreferences[0].CommunicationTypeId =
        MarketingPreferenceCommunicationType.TextOrSMS;
      this.applicant.Instance.MarketingPreferences = this.appMarketingPreferences;
    });
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  handleForm() {
    this.tad_applicant_details_form = this.fb.group({
      tad_address_applicant_number: this.tad_address_applicant_number,
      tad_applicant_title: this.tad_applicant_title,
      tad_first_name: this.tad_first_name,
      tad_middle_name: this.tad_middle_name,
      tad_last_name: this.tad_last_name,
      tad_dob_day: this.tad_dob_day,
      tad_dob_month: this.tad_dob_month,
      tad_dob_year: this.tad_dob_year,
      tad_main_phone_number: this.tad_main_phone_number,
      tad_email_address: this.tad_email_address,
      tad_marketing_approval: this.tad_marketing_approval,
      tad_property_house_name_number: this.tad_property_house_name_number,
      tad_property_street_1: this.tad_property_street_1,
      tad_property_town_city: this.tad_property_town_city,
      tad_property_district: this.tad_property_district,
      tad_property_county: this.tad_property_county,
      tad_property_postcode: this.tad_property_postcode,
      tad_addresses: this.tad_addresses,
      address_search: this.address_search,
      phone: this.phone,
      email: this.email,
      post: this.post,
      sms: this.sms,
    }, {
      validator: this.validateFields('tad_dob_day',
        'tad_dob_month', 'tad_dob_year', 'tad_marketing_approval'),
    });
  }



  /**
   * Retrieves form back from the MID/address component, to ensure valid before allowing submit.
   *
   * @param {any} form
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  _handleFormInFromAddress(form) {
    this.changedYear = 0;

    // Get the form as a typed FormGroup.
    const movedInForm: UntypedFormGroup = form.form as UntypedFormGroup;
    const iter = _.toInteger(form.iterator);

    this.handleForm();

    if (movedInForm.get('tad_moved_in_date_month').valid) {
      // Now bind the date coming in from this.
      const month = movedInForm.get('tad_moved_in_date_month').value;
      const year = movedInForm.get('tad_moved_in_date_year').value;
      const yearstr = _.toString(year);
      const yearlength = _.isNil(year) ? 0 : yearstr.length;
      const date = _.isNil(month) || yearlength !== 4 ? null : new Date(year, month - 1, 1);
      // Now update the dates.
      this._movedInDates[iter] = date;

      if (form.hasYearChanges) {
        this.handleAddressLoop(iter);
      }
    }

    this.handleUpdateApplicantModel(iter);
    // Now pass back to parent element.
    this.pass_form.emit(this.tad_applicant_details_form);

  }


  /**
   * Handles binding of address coming back from the MID/address component,
   *  to ensure that the address is correct.
   *
   * @param {any} address
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  handleAddressInFromAddress(address) {

    // Bind address to the same position in the list.
    this._addresses[address.iterator] = address.address;

    // Correct the date coming from the address input.
    // tslint:disable-next-line:max-line-length
    const effectiveFromDate = address.address['EffectiveFromDate'];
    const date = _.isNil(effectiveFromDate) ? null : new Date(effectiveFromDate);
    const mon = date.getMonth() + 1;

    // Now we need to append the date to the movedInDates
    this._movedInDates[address.iterator] = date;
  }

  /**
   *
   *
   * @param {Date} date
   * @returns
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  isDateWithin3Years(date: Date) {
    return moment(new Date()).diff(date, 'years') < 3; // Te amo!
  }

  /**
   *
   *
   * @returns array which determines has addres initialised
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  hasInitialisedAddresses() {
    const addresses: Array<any> = this.tad_applicant_details_form.get('tad_addresses').value;
    return _.isArray(addresses) && addresses.length > 0;
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  handleForceRefresh() {
    this.ref.detectChanges();
  }

  /**
   *
   * @param {any} iter
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  handleUpdateApplicantModel(iter) {
    const addr = _.isNil(this.movedInAddresses[iter]) ? null :
      this.movedInAddresses[iter]['LegalBodyRoleAddress'];
    const fields = this.tad_addresses.controls[iter];

    if (!_.isNil(addr)) {
      if (_.isNil(fields) === false && fields.valid) {
        const addressFormGroup: UntypedFormGroup =
          fields.get('tad_applicant_address') as UntypedFormGroup;
        const hasControls = Object.keys(addressFormGroup.controls).length > 0;

        if (hasControls) {
          addr.HouseName =
            _.defaultTo(addressFormGroup.get('addressHouseName').value, '');
          addr.HouseNumber =
            _.defaultTo(addressFormGroup.get('addressHouseNumber').value, '');
          addr.District = _.defaultTo(addressFormGroup.get('addressDistrict').value, '');
          addr.County = _.defaultTo(addressFormGroup.get('addressCounty').value, '');
          addr.Street = _.defaultTo(addressFormGroup.get('addressStreet').value, '');
          addr.Street1 = _.defaultTo(addressFormGroup.get('addressStreet').value, '');
          addr.Street2 = _.defaultTo(addressFormGroup.get('addressStreet').value, '');
          addr.PostTown = addressFormGroup.get('addressTownCity').value;
          addr.Postcode = addressFormGroup.get('addressPostcode').value;
        }
        const year = fields.get('tad_moved_in_date_year').value;
        const yearstr = _.toString(year);
        const yearlength = _.isNil(year) ? 0 : yearstr.length;
        const month = fields.get('tad_moved_in_date_month').value;
        const date = new Date(year, month - 1, 1);
        date.setHours(0, -date.getTimezoneOffset(), 0, 0);
        addr['EffectiveFromDate'] =
          yearlength !== 4 || _.isNil(month) ? null : date.toISOString();

        this.movedInAddresses[iter]['LegalBodyRoleAddress'] = addr;
        this.applicant.Instance.LegalBodyRoleAddresses =
          _.transform(this.movedInAddresses, (iter, n) => {
            iter.push(n['LegalBodyRoleAddress']);
            return true;
          }, []);
        this.applicant.Instance.MarketingPreferences = this.appMarketingPreferences;
      }
    }
  }

  /**
   *
   * @param {number} iter
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  handleAddressLoop(iter: number) {

    // Now we have all the addresses and the elements, firstly,
    // let's check and see if a new element is needed.
    const validDates: Array<boolean> = this.movedInAddresses.map((control) => {
      const dateFull = new Date(control['LegalBodyRoleAddress']['EffectiveFromDate']);
      return this.isDateWithin3Years(dateFull);
    });

    // Does the array have a valid index in it? (i.e. an address not within 3 years. )
    const falsePositon = validDates.indexOf(false);
    const isValid = falsePositon !== -1;
    const hasBreak = (falsePositon !== -1) && (falsePositon < validDates.length - 1);

    if (hasBreak) {

      // Find out where to trim off.
      const breakPlace = _.toInteger(validDates.indexOf(false));

      const originalArray =
        this.movedInAddresses.splice(0, breakPlace + 1);
      if (this.movedInAddresses.length > 0) {
        this.movedInAddresses.forEach(x =>
          this._handleDeleteAddress(x['LegalBodyRoleAddress']['Id'],
            this.incoming_case_id));
      }
      this.movedInAddresses = originalArray;
      this.handleForm();

    }


    const addresses = this.tad_applicant_details_form.get('tad_addresses') as UntypedFormArray;

    const monthCtrl = addresses.controls[iter].get('tad_moved_in_date_month') as UntypedFormControl;
    const yearCtrl = addresses.controls[iter].get('tad_moved_in_date_year') as UntypedFormControl;

    const monthValue = monthCtrl.value;
    const yearValue = yearCtrl.value;

    const dateY = yearValue + ' ' + monthValue + ' ' + 1;
    const isDateValid = moment(dateY, 'YYYY MM DD');
    const future = moment().add({ day: 1 });
    const eachValid = [_.isNil(monthValue) === false, _.isNil(yearValue) === false];
    const valuesUpdated = _.includes(eachValid, true);
    const allValuesSet = eachValid.every(p => p === true);

    if (this.hasInitialisedAddresses()
      && addresses.controls[iter].get('tad_moved_in_date_year').valid
      && isDateValid.isValid && isDateValid.isAfter(future, 'day') === false
      && allValuesSet) {
      if (isValid === false) {
        if (this.tad_applicant_details_form.get('tad_addresses').value.length
          === this.movedInAddresses.length && this.movedInAddresses.length < 3) {
          this.movedInAddresses.push({
            LegalBodyRoleAddress:
              new TogetherAuctionDIPApplicantDetailsLegalBodyRoleAddresses(),
          });

          this.handleForceRefresh();
        }
      }
    }
  }

  /**
   *
   * @param {any} form
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  handleHasLived3year(form) {
    this._haslived3year = form.haslived3year;
    if (form.haslived3year && this.movedInAddresses.length > 1) {
      this.ref.detach();
      const originalArray = this.movedInAddresses.splice(0, 1);
      this.movedInAddresses.forEach((x) => {
        if (!_.isNil(x['LegalBodyRoleAddress']['Id'])
          && this.api.isNew(x['LegalBodyRoleAddress']['Id']) === false) {
          this._handleDeleteAddress(x['LegalBodyRoleAddress']['Id'],
            this.incoming_case_id);
        }
      });
      this.changedYear = 0;
      this.movedInAddresses = originalArray;
      this.handleForm();
      this.ref.reattach();
    }
  }

  /**
   * Prepare the applicant object when the form is submitted.
   *
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  prepareApplicantSave(do_save = false) {
    if (!_.isNil(this.applicant)) {

      const title = _.isString(this.tad_applicant_title.value) ?
        this.tad_applicant_title.value : this.tad_applicant_title.value.value;
      this.applicant.Instance._Title = title;
      this.applicant.Instance.MarketingPreferences = this.appMarketingPreferences;
      this.applicant.Instance.FirstName = this.tad_first_name.value;
      this.applicant.Instance.MiddleName = this.tad_middle_name.value;
      this.applicant.Instance.Surname = this.tad_last_name.value;
      this.applicant.uiEmail = this.email.value;
      this.applicant.uiPhone = this.phone.value;
      this.applicant.uiPost = this.post.value;
      this.applicant.uiSms = this.sms.value;

      if (this.tad_dob_day.valid && this.tad_dob_month.valid && this.tad_dob_year.valid) {
        this.applicant._ui_birthdate_day = this.tad_dob_day.value;
        this.applicant._ui_birthdate_month = this.tad_dob_month.value;
        this.applicant._ui_birthdate_year = this.tad_dob_year.value;
      }
      this.applicant._ui_phone_number = this.tad_main_phone_number.value;
      this.applicant._ui_email_address = this.tad_email_address.value;
      this.applicant.Instance.OkToContact = this.tad_marketing_approval.value;

      if (this.is_business_applicant === true) {
        this.applicant.Instance.IsCompanyApplication = true;
      } else {
        this.applicant.Instance.IsCompanyApplication = false;
      }

      if (do_save) {
        this._handleSaveData(
          this.incoming_case_id,
          this.applicant.Instance.Id,
          this.applicant.Instance,
        );
      }
    }
  }


  /**
   *
   *
   * @param {string} title
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  titleChange(title: string): void {
    this.tad_applicant_title.setValue(title);
  }

  /**
   *
   * @param {string} control
   * @returns
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  setDynamicClasses(control: string) {
    return {
      'is-invalid form-control-danger': this.tad_applicant_details_form.get(control).touched
        && this.tad_applicant_details_form.get(control).invalid,
      'is-valid form-control-success': this.tad_applicant_details_form.get(control).touched
        && this.tad_applicant_details_form.get(control).valid,
    };
  }

  /**
   *
   * @param {string} control
   * @returns
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  setDynamicClassesForFormgroup(control: string) {
    return {
      'is-invalid': this.tad_applicant_details_form.get(control).touched
        && this.tad_applicant_details_form.get(control).invalid,
      'is-valid': this.tad_applicant_details_form.get(control).touched
        && this.tad_applicant_details_form.get(control).valid,
    };
  }

  /**
   *
   *
   * @param {any} addr_id
   * @param {any} case_id
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  _handleDeleteAddress(addr_id, case_id) {
    if (!_.isNil(addr_id) && this.api.isNew(addr_id) === false) {
      this.ref.detach();
      this.isLoading = true;
      this.api.deleteEntities(TogetherAuctionDIPEntityType.ApplicantAddress,
        case_id,
        addr_id, null)
        .pipe(takeUntil(this.ngUnsubscribeDelete))
        .subscribe(
          (success) => {
            this.isLoading = false;
            this.ref.reattach();
          },
          (error) => {
            this.exception.haveReceivedError(error);
            this.isLoading = false;
          });

    }
  }

  /**
   *
   *
   * @param {boolean} value
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  toggelMarketingPreference(value: boolean) {
    if (!value) {
      this.email.setValue(false);
      this.phone.setValue(false);
      this.post.setValue(false);
      this.sms.setValue(false);
      this.appMarketingPreferences[0].ContactByEmail = false;
      this.appMarketingPreferences[0].ContactByPhone = false;
      this.appMarketingPreferences[0].ContactByPost = false;
      this.appMarketingPreferences[0].ContactByTextOrSMS = false;
      this.applicant.Instance.MarketingPreferences = this.appMarketingPreferences;
    }
  }


  /**
   * Creates an instance of TogetherAuctionDIPApplicantDetailComponent.
   * @param {FormBuilder} fb
   * @param {NodeAPIService} api
   * @memberof TogetherAuctionDIPApplicantDetailComponent
   */
  constructor(private api: NodeAPIEntityService,
    private fb: UntypedFormBuilder,
    private ref: ChangeDetectorRef,
    private exception: ExceptionService) {
    this.handleForm();
  }
}
